const CHAT_RESET_MESSAGE = '/reset';
const CHAT_CLEAR_MESSAGE = '/clear';
const CHAT_NEW_MESSAGE = '/new';
const CHAT_INCLUDE_MESSAGE = '/include';
const LOADING_TRANSITION_DURATION = 7500;
const DOCUMENTATION_SOURCE_TYPES = {
  HANDBOOK: {
    value: 'handbook',
    icon: 'book'
  },
  DOC: {
    value: 'doc',
    icon: 'documents'
  },
  BLOG: {
    value: 'blog',
    icon: 'list-bulleted'
  }
};
const MESSAGE_MODEL_ROLES = {
  user: 'user',
  system: 'system',
  assistant: 'assistant',
  tool: 'tool',
  request: 'request',
  workflow_end: 'workflow_end'
};
const SELECTED_CONTEXT_ITEMS_DEFAULT_COLLAPSED = true;

// TODO this should be a shared util in GitLab UI
const badgeTypes = ['experiment', 'beta', null];
const badgeTypeValidator = value => badgeTypes.includes(value);

export { CHAT_CLEAR_MESSAGE, CHAT_INCLUDE_MESSAGE, CHAT_NEW_MESSAGE, CHAT_RESET_MESSAGE, DOCUMENTATION_SOURCE_TYPES, LOADING_TRANSITION_DURATION, MESSAGE_MODEL_ROLES, SELECTED_CONTEXT_ITEMS_DEFAULT_COLLAPSED, badgeTypeValidator, badgeTypes };
